module.exports = __webpack_public_path__ + "img/p3.96696a84.png";